import * as React from "react";
import { useFormContext } from "react-hook-form";
import { DropdownInput } from "../../../runQuote/components/DropdownInput";
import { SwitchInput } from "../../../runQuote/components/SwitchInput";

const BI_PD = [
  { value: "50/100/50", label: "50/100/50" },
  { value: "100/300/100", label: "100/300/100" },
  { value: "250/500/100", label: "250/500/100" },
];

const UMPD = [
  { value: "Reject", label: "Reject" },
  { value: "25k", label: "25k" },
  { value: "50k", label: "50k" },
  { value: "100k", label: "100k" },
];

const MED_PAY = [
  { value: "Reject", label: "Reject" },
  { value: "$1k", label: "$1k" },
  { value: "$2k", label: "$2k" },
  { value: "$5k", label: "$5k" },
  { value: "$10k", label: "$10k" },
];

const PIP = [
  { value: "Reject", label: "Reject" },
  { value: "$2.5k", label: "$2.5k" },
  { value: "$5k", label: "$5k" },
  { value: "$10k", label: "$10k" },
];

const COMP_DED = [
  { value: "Reject", label: "Reject" },
  { value: "100", label: "100" },
  { value: "250", label: "250" },
  { value: "500", label: "500" },
  { value: "750", label: "750" },
  { value: "1000", label: "1000" },
  { value: "1500", label: "1500" },
  { value: "2000", label: "2000" },
  { value: "100(glass)", label: "100(glass)" },
  { value: "250(glass)", label: "250(glass)" },
  { value: "500(glass)", label: "500(glass)" },
  { value: "750(glass)", label: "750(glass)" },
  { value: "1000(glass)", label: "1000(glass)" },
  { value: "1500(glass)", label: "1500(glass)" },
  { value: "2000(glass)", label: "2000(glass)" },
];

const COLL_DED = [
  { value: "Reject", label: "Reject" },
  { value: "100", label: "100" },
  { value: "250", label: "250" },
  { value: "500", label: "500" },
  { value: "750", label: "750" },
  { value: "1000", label: "1000" },
  { value: "1500", label: "1500" },
  { value: "2000", label: "2000" },
];

const PAYMENT_PLAN = [
  { value: "Pay In Full", label: "Pay In Full" },
  { value: "Monthly EFT", label: "Monthly EFT" },
  { value: "Monthly CC", label: "Monthly CC" },
];

export function Coverages() {
  const { control } = useFormContext();

  return (
    <div className="space-y-6">
      <h2 className="text-2xl font-semibold">Coverages</h2>

      <DropdownInput
        control={control}
        label="Bodily Injury & Property Damage"
        dropdownLabel="Select"
        stepName="step6.bodilyInjury"
        stepId="step6"
        itemList={BI_PD}
      />

      <SwitchInput
        control={control}
        id="umbi"
        stepName="step6.umbi"
        stepId="step6"
        label="Uninsured/Underinsured Motorist Bodily Injury (matches BI limit if selected)"
      />

      <DropdownInput
        control={control}
        label="Uninsured/Underinsured Motorist Property Damage"
        dropdownLabel="Select"
        stepName="step6.umPropertyDamage"
        stepId="step6"
        itemList={UMPD}
      />

      <DropdownInput
        control={control}
        label="Med Pay"
        dropdownLabel="Select"
        stepName="step6.medPay"
        stepId="step6"
        itemList={MED_PAY}
      />
      <p className="text-xs text-gray-500">Limits may vary by state.</p>

      <DropdownInput
        control={control}
        label="PIP"
        dropdownLabel="Select"
        stepName="step6.pip"
        stepId="step6"
        itemList={PIP}
      />
      <p className="text-xs text-gray-500">
        Limits may vary by state and PIP may not be offered in all states.
      </p>

      <DropdownInput
        control={control}
        label="Comp Deductible"
        dropdownLabel="Select"
        stepName="step6.compDeductible"
        stepId="step6"
        itemList={COMP_DED}
      />

      <DropdownInput
        control={control}
        label="Collision Deductible"
        dropdownLabel="Select"
        stepName="step6.collisionDeductible"
        stepId="step6"
        itemList={COLL_DED}
      />

      <DropdownInput
        control={control}
        label="Payment Plan"
        dropdownLabel="Select"
        stepName="step6.paymentPlan"
        stepId="step6"
        itemList={PAYMENT_PLAN}
      />
      <p className="text-xs text-gray-500">Pay by mail or cash is not offered.</p>

      <SwitchInput
        control={control}
        id="runClue"
        stepName="step6.runClue"
        stepId="step6"
        label="Would you like Cover Badger to Run Clue/MVR for this insured prior to returning a quote?"
      />
      <p className="text-xs text-gray-500">
        All agencies are required to pay for all Clue and MVR reports which will be applied to their commission statement.
      </p>

    </div>
  );
}
